import { useQuery } from '@tanstack/react-query'
import {
  fetchPollingSnapshots,
  pollingSnapshotKeys,
} from '@/services/pollingSnapshots'
import type { PollingSnapshot } from '@/types'

/**
 * Hook to get polling snapshots for a party.
 *
 * Returns polls ordered by tick (most recent first), limited to specified count.
 *
 * @param partyId - The party to fetch polls for (optional, hook is disabled if undefined)
 * @param limit - Maximum number of polls to fetch (default 10)
 * @returns Object with polls array, plus loading/error states
 */
export function usePollingSnapshots(
  partyId: string | undefined,
  limit: number = 10
) {
  const query = useQuery({
    queryKey: pollingSnapshotKeys.byPartyLimited(partyId!, limit),
    queryFn: () => fetchPollingSnapshots(partyId!, limit),
    enabled: !!partyId,
  })

  return {
    polls: (query.data ?? []) as PollingSnapshot[],
    isLoading: query.isLoading,
    error: query.error,
  }
}
